(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enz-best-seller"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof Swiper === 'undefined') return;

    const roots = document.querySelectorAll('[data-enz-best-seller-root]');
    roots.forEach((root) => {
      const el = root.querySelector('[data-enz-best-seller-swiper]');
      if (!el) return;

      const slidesCount = el.querySelectorAll('.swiper-slide').length;
      if (slidesCount === 0) return;

      const swiper = new Swiper(el, {
        spaceBetween: 16,
        slidesPerView: 1,
        rewind: true,
        watchSlidesProgress: true, 
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 16
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
                initialSlide: 2
            }
        }
      });


      const counterEl = root.querySelectorAll('.enz-best-sellers .enz-swiper-navigation-counter');

      const carouselPrev = root.querySelectorAll('.enz-best-sellers .enz-swiper-navigation-prev');
      const carouselNext = root.querySelectorAll('.enz-best-sellers .enz-swiper-navigation-next');

     carouselPrev.forEach((prev) => {
        prev.addEventListener('click', (e) => {
          e.preventDefault();
          swiper.slidePrev();
        })
      });

      carouselNext.forEach((next) => {
        next.addEventListener('click', (e) => {
          e.preventDefault();
          swiper.slideNext();
        }) 
      });

      const updateCounter = () => {
        if (!counterEl) return;
        const total = swiper.slides ? swiper.slides.length : slidesCount;
        const current = (swiper.realIndex || 0) + 1;
        counterEl.forEach((el) => {
          el.textContent = current + ' / ' + total + ' products';
        });
      }

      updateCounter();
      swiper.on('slideChange', updateCounter);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enz-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function marquee(root) {
        const speed =  0.04;
        const parentSelector = root.querySelector('.enz-hero-banner-cvps');
        if (!parentSelector) return;

        function cloneChildren(cvpWrapper) {
            var children = Array.from(cvpWrapper.children);
            children.forEach(function (item) {
                var clonedChild = item.cloneNode(true);
                cvpWrapper.appendChild(clonedChild);
            });
        }

        const cvpWrapper = parentSelector.querySelector('.enz-hero-banner-cvps--swiper');
        if (!cvpWrapper) return;

        const firstElement = parentSelector.children[0];
        const originalSetWidth = cvpWrapper ? cvpWrapper.scrollWidth : 0;

        cloneChildren(cvpWrapper);
        cloneChildren(cvpWrapper);

        let offset = 0;
        let lastTs = null;

        function animate(ts) {
            if (lastTs == null) lastTs = ts;
            const dt = ts - lastTs;
            lastTs = ts;
            
            // speed is px per ms (adjust to taste)
            offset += speed * dt;
            
            // Wrap BEFORE we reach the end of the original set.
            if (originalSetWidth > 0) {
                offset = offset % originalSetWidth;
            } else if (firstElement.scrollWidth > 0) {
                offset = offset % firstElement.scrollWidth;
            }
            
            firstElement.style.marginLeft = `-${offset}px`;
            requestAnimationFrame(animate);
        }
 
        requestAnimationFrame(animate);
    }

    marquee(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enz-instagram-stories"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {

        const waitFor = (selector, { timeoutMs = 15000, intervalMs = 100 } = {}) => {
            return new Promise((resolve, reject) => {
                const start = Date.now();
                const tick = () => {
                    const el = document.querySelector(selector);
                    if (el) return resolve(el);
                    if (Date.now() - start >= timeoutMs) return reject(new Error('Timeout waiting for ' + selector));
                    setTimeout(tick, intervalMs);
                };
                tick();
            });
        };

        Promise.all([
            waitFor('#insta-feed .instafeed-new-layout-item'),
            waitFor('.enz-instagram-stories .instafeed-new-layout-container'),
            waitFor('.enz-instagram-stories .instafeed-new-arrow.instafeed-new-arrow-prev'),
            waitFor('.enz-instagram-stories .instafeed-new-arrow.instafeed-new-arrow-next')
        ])
            .then(() => {
                const counter = document.createElement('span');
                counter.className = 'enz-swiper-navigation-counter';
                const total_reels = document.querySelectorAll('.enz-instagram-stories #insta-feed .instafeed-new-layout-item').length;

                document.querySelectorAll('.enz-instagram-stories #insta-feed .instafeed-new-layout-item').forEach((item, index) => {
                    item.setAttribute('data-index', index + 1);
                });

                const updateCounter = (index) => {
                    counter.textContent = (index) + ' / ' + total_reels + ' reels';
                };

                updateCounter(1);
                document.querySelector('.enz-instagram-stories .enz-instagram-carousel-wrapper').appendChild(counter);
                
                const carousel_wrapper = document.querySelector('.enz-instagram-stories .enz-instagram-carousel-wrapper');
        
                const observerOptions = {
                    root: carousel_wrapper,
                    threshold: 0.5
                };

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const index = parseInt(entry.target.getAttribute('data-index'));
                            updateCounter(index);
                            entry.target.classList.add('is-visible');
                        } else {
                            entry.target.classList.remove('is-visible');
                        }
                    });
                }, observerOptions);

                document.querySelectorAll('.enz-instagram-stories #insta-feed .instafeed-new-layout-item').forEach(slide => observer.observe(slide));

                // if (window.innerWidth > 768) {
                //     const arrowLeft = document.querySelector('.enz-instagram-stories .instafeed-new-arrow-next');
                //     for (let i = 0; i < 3; i++) {
                //       setTimeout(() => {
                //         arrowLeft.click();
                //       }, 500 * (i + 1));
                //     }
                // }
            })
            .catch(() => {});
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enz-reviews"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        const waitFor = (selector, { timeoutMs = 15000, intervalMs = 100 } = {}) => {
            return new Promise((resolve, reject) => {
                const start = Date.now();
                const tick = () => {
                    const el = document.querySelector(selector);
                    if (el) return resolve(el);
                    if (Date.now() - start >= timeoutMs) return reject(new Error('Timeout waiting for ' + selector));
                    setTimeout(tick, intervalMs);
                };
                tick();
            });
        };

        Promise.all([
            waitFor('.enz-reviews .jdgm-carousel-item'),
            waitFor('.enz-reviews .jdgm-carousel__arrows'),
            waitFor('.enz-reviews .jdgm-carousel__left-arrow'),
            waitFor('.enz-reviews .jdgm-carousel__right-arrow'),
            waitFor('.enz-reviews .jdgm-carousel__item-wrapper')
        ])
        .then(() => {
            
            const counter = document.createElement('span');
            counter.className = 'enz-swiper-navigation-counter';
            const total_reviews = document.querySelectorAll('.enz-reviews .jdgm-carousel-item').length;

            document.querySelectorAll('.enz-reviews .jdgm-carousel-item').forEach((item, index) => {
                item.setAttribute('data-index', index + 1);
            });

            const updateCounter = (index) => {
                counter.textContent = (index) + ' / ' + total_reviews + ' reviews';
            };

            updateCounter(1);
            document.querySelector('.enz-reviews .jdgm-carousel__arrows').appendChild(counter);

            const carousel_wrapper = document.querySelector('.enz-reviews .jdgm-carousel__item-container');
        
            const observerOptions = {
                root: carousel_wrapper,
                threshold: 0.5
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const index = parseInt(entry.target.getAttribute('data-index'));
                        updateCounter(index);
                        entry.target.classList.add('is-visible');
                    } else {
                        entry.target.classList.remove('is-visible');
                    }
                });
            }, observerOptions);

            document.querySelectorAll('.enz-reviews .jdgm-carousel-item').forEach(slide => observer.observe(slide));
        })
        .catch(() => {});
    });

  } catch(e) { console.error(e); }
})();
})();
